import { queryOptions } from '@tanstack/react-query'
import { PublicProgramKeys } from '@/app/pages/authentication/registration/query_key_factory.ts'
import {
  getPublicPrograms,
  GetUserPrograms,
  UserProgramList,
} from '@/queries/programs/requests.ts'
import { CustomQueryOptions } from '@/app/common/types_and_interfaces'

const UserProgramsKeys = {
  programsByUser: (user_id: number) => ['user_program_list', user_id],
  programSettings: (program_id: number) => ['program_settings', program_id],
} as const
export class PublicProgramQueries {
  public static index() {
    return queryOptions({
      queryKey: PublicProgramKeys.allPublicPrograms,
      queryFn: getPublicPrograms,
    })
  }

  public static FetchUserPrograms(
    user_id?: number,
    options: CustomQueryOptions<UserProgramList> = {}
  ) {
    return queryOptions({
      queryKey: UserProgramsKeys.programsByUser(user_id!),
      queryFn: () => GetUserPrograms(user_id),
      ...options,
    })
  }

}

